import { useState, useEffect } from "react";
import { Monitor } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const MOBILE_WARNING_DISMISSED_KEY = "mobile_warning_dismissed";

export function MobileWarningDialog() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Only show if mobile and hasn't been dismissed this session
    if (isMobile && !sessionStorage.getItem(MOBILE_WARNING_DISMISSED_KEY)) {
      setOpen(true);
    }
  }, [isMobile]);

  const handleDismiss = () => {
    sessionStorage.setItem(MOBILE_WARNING_DISMISSED_KEY, "true");
    setOpen(false);
  };

  if (!isMobile) return null;

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent className="max-w-sm">
        <AlertDialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent/10">
            <Monitor className="h-6 w-6 text-accent" />
          </div>
          <AlertDialogTitle className="text-center">
            Optimerad för dator
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            Samfora är utformat för att användas på en datorskärm. För bästa upplevelse rekommenderar vi att du loggar in från din dator.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center">
          <AlertDialogAction onClick={handleDismiss}>
            Jag förstår
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
